export const DefaultSpacings = {
  0: '0rem' as const,
  2: '0.2rem' as const,
  4: '0.4rem' as const,
  6: '0.6rem' as const,
  8: '0.8rem' as const,
  10: '1rem' as const,
  12: '1.2rem' as const,
  14: '1.4rem' as const,
  16: '1.6rem' as const,
  18: '1.8rem' as const,
  20: '2rem' as const,
  22: '2.2rem' as const,
  24: '2.4rem' as const,
  26: '2.6rem' as const,
  28: '2.8rem' as const,
  30: '3rem' as const,
  32: '3.2rem' as const,
  34: '3.4rem' as const,
  36: '3.6rem' as const,
  38: '3.8rem' as const,
  40: '4rem' as const,
  42: '4.2rem' as const,
  44: '4.4rem' as const,
  46: '4.6rem' as const,
  48: '4.8rem' as const,
  50: '5rem' as const,
  52: '5.2rem' as const,
  54: '5.4rem' as const,
  56: '5.6rem' as const,
  58: '5.8rem' as const,
  60: '6rem' as const,
  64: '6.4rem' as const,
  68: '6.8rem' as const,
  72: '7.2rem' as const,
  76: '7.6rem' as const,
  80: '8rem' as const,
  84: '8.4rem' as const,
  88: '8.8rem' as const,
  92: '9.2rem' as const,
  96: '9.6rem' as const,
  100: '10rem' as const,
  120: '12rem' as const,
  140: '14rem' as const,
  160: '16rem' as const,
  220: '22rem' as const,
  240: '24rem' as const,
  auto: 'auto' as const,
}

export type Spacings = typeof DefaultSpacings
